export class InputUtils {
  static allowLettersOnly(event: KeyboardEvent): void {
    const regex = /^[A-Za-zÄÖÜäöüß\s\-]$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }
}
